import React from 'react';
import ReactDOM from 'react-dom';
import App from './Containers/App';
ReactDOM.render(<App title='CRUD'/>,document.querySelector("#root"));


// WEBPACK FOOTER //
// ./src/index.js